// extracted by mini-css-extract-plugin
module.exports = {"logo":"Footer_logo__3ACxa","wrapper":"Footer_wrapper__1UzXs","content":"Footer_content__27StV","tcwrap":"Footer_tcwrap__2zZlv","termsconditions":"Footer_termsconditions__27m0e"};